module.exports = __webpack_public_path__ + "static/media/backendless-logo.4869a63d.svg";